/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

/********************************************************** 

Mobile Nav Menu - https://codepen.io/PaulVanO/pen/XJYGNQ */

(function($) {
  $('#Toggle').click(function() {
   $(this).toggleClass('active');
   $('#Overlay').toggleClass('open');
 });
})(jQuery);

/****************************************************************** 

Timeline Bounce JS - https://codyhouse.co/gem/vertical-timeline/ */

(function($) {
  var timelineBlocks = $('.cd-timeline-block'),
  offset = 0.7;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      (!window.requestAnimationFrame)
      ? setTimeout(function () {
        showBlocks(timelineBlocks, offset);
      }, 100)
      : window.requestAnimationFrame(function () {
        showBlocks(timelineBlocks, offset);
      });
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  })(jQuery);

  (function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

   $.fn.visible = function(partial) {

    var $t            = $(this),
    $w            = $(window),
    viewTop       = $w.scrollTop(),
    viewBottom    = viewTop + $w.height(),
    _top          = $t.offset().top,
    _bottom       = _top + $t.height(),
    compareTop    = partial === true ? _bottom : _top,
    compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };

})(jQuery);

jQuery(document).ready(function($) {

  var stripe = Stripe('pk_live_LlAg1diPsqZXshYLIdWmMc1e');
  var win = $(window);

  var allMods = $(".module");

  var allMods2 = $(".module2");

  allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("already-visible"); 
    } 
  });

  win.scroll(function(event) {

    allMods.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in"); 
      } 
    });
    
  });

  win.scroll(function(event) {

    allMods2.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("flipInX"); 
      } 
    });
    
  });

  if (jQuery('#pay-a-bill').length) {
    //validate select your area
    //post to value of selected item
    jQuery('#pay-a-bill').parsley()
        .on('field:validated', function () {
            var ok = jQuery('.parsley-error').length === 0;
            jQuery('.bs-callout-warning').toggleClass('hidden', ok);
        })
        .on('form:submit', function () {
            //is ready to submit
            var data = {
                'name': jQuery('#name').val(),
                'amount': jQuery('#amount').val(),
                'invoiceNumber': jQuery("#invoice-number").val(),
                'email': jQuery("#email").val(),
                '_wpnonce': jQuery("#_wpnonce").val()
            };
            jQuery.post('/app/themes/fusio/submit-pay-a-bill.php', data, function (data) {
              var obj = JSON.parse(data);
              console.log(obj.return);
                var session = obj.session;
                if (obj.return == 'success') {

                  stripe.redirectToCheckout({
                    // Make the id field from the Checkout Session creation API response
                    // available to this file, so you can provide it as parameter here
                    // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                    sessionId: session
                  }).then(function (result) {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                  });

                } else {
                  //warning message
                  responseHTML = "<div class='failure'><h2>Sorry</h2><p>Something went wrong, please try again</p></div>";
                  //div of the warning message at the top of the form, show it
                  jQuery('.bs-callout-warning').toggleClass('hidden', false);
                  //set the text of the warning message
                  jQuery('.bs-callout-warning').html(responseHTML);
                }
            });
        });
}

});